import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

interface ComingSoonProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ComingSoon({ open, onOpenChange }: ComingSoonProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-4 flex justify-center">
            <img
              src="/LearnBahn.png"
              alt="LearnBahn Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
          <DialogTitle className="text-center text-2xl font-bold">
            🚀 Coming Soon!
          </DialogTitle>
          <DialogDescription className="text-center text-gray-600">
            Welcome to LearnBahn! We're putting the finishing touches on your
            personalized learning experience.
          </DialogDescription>
        </DialogHeader>

        <div className="py-6">
          <div className="text-center space-y-4">
            <div className="bg-gradient-to-r from-orange-50 to-purple-50 rounded-lg p-6">
              <h3 className="font-semibold text-gray-900 mb-3">
                What's Coming Next?
              </h3>
              <ul className="text-sm text-gray-600 space-y-2 text-left">
                <li className="flex items-center">
                  <svg
                    className="w-4 h-4 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Personalized learning dashboard
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-4 h-4 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Interactive course content
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-4 h-4 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  AI-powered progress tracking
                </li>
                <li className="flex items-center">
                  <svg
                    className="w-4 h-4 text-green-500 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Mobile app integration
                </li>
              </ul>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex items-center justify-center mb-2">
                <svg
                  className="w-5 h-5 text-yellow-600 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="text-sm font-medium text-yellow-800">
                  Stay Tuned!
                </span>
              </div>
              <p className="text-sm text-yellow-700">
                We'll notify you as soon as your learning environment is ready.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-3">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Back to Login
          </Button>
          <Button
            onClick={() => {
              // In a real app, this might open a notification signup or redirect
              window.open(
                'mailto:support@learnbahn.com?subject=Notify me when ready',
                '_blank'
              );
            }}
          >
            Get Notified
          </Button>
        </div>

        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Thank you for your patience as we build something amazing! ✨
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
